import _ from 'lodash'

class MenuItem {
  constructor(data, parent) {
    this._id = _.uniqueId('nav-store-')

    this.title = data.title
    this.pageTitle = data.pageTitle
    this.route = data.route
    this.icon = data.icon
    this.badge = data.badge
    this.counter = data.counter

    this.parent = parent

    if (data.items) {
      this.items = _.map(data.items, child => new MenuItem(child, this))
    }

    this.isOpen = this._isOpen()
    this.isActive = this._isActive()

    return this
  }
  _isOpen() {
    return (
      _.startsWith(MenuItem.getRoute(), this.route) || this._hasOpenChildren()
    )
  }
  _hasOpenChildren() {
    return _.some(this.items, function(item) {
      return item._isOpen()
    })
  }
  _isActive() {
    return (
      MenuItem.getRoute() === this.route || (this._isOpen() && !this.parent)
    )
  }
  updateActive() {
    this.isActive = this._isActive()
  }
  isSibling(item) {
    return (
      this._id !== item._id &&
      this.parent &&
      _.some(
        this.parent.items,
        child => child._id === item._id && child._id !== this._id
      )
    )
  }
  isParentOf(item) {
    return (
      this.items &&
      _.some(
        this.items,
        _item => _item._id === item._id || _item.isParentOf(item)
      )
    )
  }
  static getRoute() {
    return window.location.pathname
  }
}

export default MenuItem
